import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseMagAdvertisment() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات تبلیغ را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetMagAdv = (search, myPC, bool, callback) => {
    MyAxios.get(`Admin_Mag_Advertisement?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetMagAdvByID = (MagAdvID, callback) => {
    MyAxios.get(`Admin_Mag_Advertisement/${MagAdvID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetMagAdvTypes = (callback) => {
    MyAxios.get(`Admin_Mag_Advertisement/types`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const AddMagAdv = (Model, Image1, Image2, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    if (Image1) {
      data.append("Image1", Image1);
    }
    if (Image2) {
      data.append("Image2", Image2);
    }
    MyAxios.post(`Admin_Mag_Advertisement`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" تبلیغ باموفقیت افزوده شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const UpdateMagAdv = (Model, Image1, Image2, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(Model));
    if (Image1) {
      data.append("Image1", Image1);
    }
    if (Image2) {
      data.append("Image2", Image2);
    }
    MyAxios.put(`Admin_Mag_Advertisement`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("ویرایش تبلیغ باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const DeleteMagAdv = (ID, callback) => {
    const data = new FormData();
    data.append("ID", ID);
    MyAxios.delete(`Admin_Mag_Advertisement`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("حذف تبلیغ باموفقیت انجام شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback(response.data.resault);
        }
      }
    );
  };

  return {
    validate,
    GetMagAdv,
    GetMagAdvByID,
    AddMagAdv,
    UpdateMagAdv,
    DeleteMagAdv,
    GetMagAdvTypes,
  };
}
